import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apis from "../../../../lib/apis/apis";
import {apiHeaders} from "../../../../lib/apiHeader";

export const getAppointmentNotes = createAsyncThunk("getAppointmentNotes", async (id, { dispatch }) => {
        try {
            const response = await axios.get(apis.get_all_notes+id, {
                headers: apiHeaders(),
            });

            if (response?.data?.success === "true") {
                return response?.data?.data;
            }
            if (response?.data?.success === false) {

                return [];
            }
        } catch (err) {

            return  []
        }
    }
);
export const storeAppointmentNotes = createAsyncThunk('storeAppointmentNotes', async (data,{dispatch}) => {
    try {
        const response = await axios.post(apis.store_notes, {...data},{
            headers: apiHeaders()
        })
        if (response?.data?.success === 'true'){
            await dispatch(getAppointmentNotes(data?.booking_id))
        }
        return  response?.data

    }catch (err){
        return err?.response?.data?.errors

    }
})



export const appointmentNotesSlice = createSlice({
    name: "appointmentNotesSlice",
    initialState: {
        notes: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAppointmentNotes.fulfilled, (state, action) => {
            state.notes = action.payload ;
        });

    },
});

export default appointmentNotesSlice.reducer;
